import {
  CreatedBy,
  DeliveryStatus,
  ScheduleMode,
} from '../../../../../../views/marketing/push-notifications/Constants';

export default {
  title: 'Kampagnen',
  filters: {
    search: 'Kampagnen suchen...',
  },
  columns: {
    title: 'Titel',
    created_by: 'Erstellt von',
    schedule_mode: 'Planungsmodus',
    scheduled_at: 'Geplant am',
    sent_at: 'Gesendet am',
    status: 'Status',
    sent: 'Gesendet',
    delivered: 'Zugestellt',
    delivered_rate: 'Zustellrate',
    clicks: 'Klicks',
    click_rate: 'Klickrate',
    live: 'Live',
    actions: 'Aktionen',
  },
  active_status: {
    draft: 'Entwurf',
    active: 'Aktiv',
  },
  delivery: {
    in_progress: 'Wartet auf Bestätigung',
    awaiting: 'Wartet auf Bestätigung',
    verified: 'Bestätigt {{relative}}',
    next_check_around: 'Nächste Prüfung gegen {{time}}',
  },
  breakdown: {
    delivered: '{{count}} zugestellt',
    pending: '{{count}} warten auf Bestätigung',
    failed_title: 'Nicht zugestellt',
    all_delivered: 'An alle Empfänger zugestellt.',
    load_error: 'Zustellungsübersicht konnte nicht geladen werden.',
    reasons: {
      DeviceNotRegistered: 'App entfernt oder Benachrichtigungen deaktiviert (Token abgelaufen)',
      MessageRateExceeded: 'Vorübergehend von Expo gedrosselt',
      MessageTooBig: 'Benachrichtigungsinhalt zu groß',
      MismatchSenderId: 'Push-Anmeldedaten stimmen nicht überein',
      InvalidCredentials: 'Ungültige Push-Anmeldedaten',
      batch_failed: 'Senden des Stapels fehlgeschlagen',
      missing_ticket: 'Keine Bestätigung von Expo erhalten',
      unknown: 'Unbekannter Zustellungsfehler',
    },
  },
  created_by: {
    [CreatedBy.System]: 'System',
    [CreatedBy.User]: 'Benutzer',
  },
  schedule_mode: {
    [ScheduleMode.Instant]: 'Sofort',
    [ScheduleMode.Scheduled]: 'Geplant',
  },
  delivery_status: {
    [DeliveryStatus.Sending]: 'Senden',
    [DeliveryStatus.Sent]: 'Gesendet',
    [DeliveryStatus.Queued]: 'In Warteschlange',
    [DeliveryStatus.Failed]: 'Fehlgeschlagen',
  },
  actions: {
    details: 'Details',
    view_details: 'Details ansehen',
    resend: 'Erneut senden',
    duplicate_edit: 'Duplizieren & Bearbeiten',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren',
  },
  success_messages: {
    campaign_deleted: 'Kampagne wurde gelöscht',
    campaign_updated: 'Kampagne wurde aktualisiert',
  },
  error_messages: {
    failed_to_load_data: 'Daten konnten nicht geladen werden',
    failed_to_delete_campaign: 'Kampagne konnte nicht gelöscht werden',
    failed_to_update_campaign: 'Kampagne konnte nicht aktualisiert werden',
  },
};
